import { AxiosConfig } from './axiosConfig';

/**
 * Preenche um html input do tipo select com os modelos dos rastreadores associados ao fabricante selecionado.
 *
 * É necessário ter dois select um com os fabricantes dos rastreadores e outro vazio que receberá os modelos
 * dos rastreadores. O select dos fabricantes deve ter o id "select-fabricante-rastreadores" e o select dos
 * modelos deve ter o id "select-modelos-rastreadores".
 */
(function () {
    const fabricanteRastreadores = $('#select-fabricante-rastreadores');
    const modelosRastreadores    = $('#select-modelos-rastreadores');
    if (fabricanteRastreadores.length === 0 || modelosRastreadores.length === 0) {
        return;
    }

    fabricanteRastreadores.on('select2:select', function (evento) {
        const objetoResposta = evento.params.data;
        if (objetoResposta.id) {
            _popularCampoSelect(objetoResposta.id);
        }
    });

    /**
     * Popula o campo select com os modelos do fabricante selecionado.
     *
     * @param {number} fabricanteId
     * @return {void}
     */
    function _popularCampoSelect (fabricanteId) {
        const axios = (new AxiosConfig()).instanciaAxios();

        axios.get(_montarUrlConsulta(fabricanteId))
        .then((response) => {
            if (Array.isArray(response.data) && response.data.length > 0) {
                let arrayModelos = [];
                response.data.forEach((modelo) => {
                    arrayModelos.push({id: modelo.id, text: modelo.nome});
                });

                modelosRastreadores.html(null);
                modelosRastreadores.select2({
                    data: arrayModelos
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

     /**
      * Url para consultar os modelos dos rastreadores.
      *
      * @param {number} fabricanteId
      * @return {string}
     */
     function _montarUrlConsulta (fabricanteId) {
        const urlSistema  = `${window.location.protocol}//${window.location.host}/rastreadores/modelos/json`;
        const camposBusca = 'campos[rastreador_modelo]=id,nome';
        const filtroBusca = `fabricanteId=${fabricanteId}`;

        return `${urlSistema}?${camposBusca}&${filtroBusca}`;
    }
})();
